export default {
  labels: {
    selectOne: 'Pumili ng isang opsyon',
    selectAll: 'Pumili ng lahat ng naaangkop',
    typeResponse: 'I-type ang iyong sagot sa kahon ng teksto sa ibaba.',
    recordResponse: 'Gumawa ng recording upang sagutin ang tanong.',
    enterNumeric: 'Ilagay ang numerong sagot sa patlang sa ibaba.',
    rateResponseScale: 'I-rate ang iyong sagot sa ibinigay na sukat.',
    sliderMinimum: 'Pinakamababang halaga: {value}',
    sliderMaximum: 'Pinakamataas na halaga: {value}',
    selectOneOptionRow: 'Pumili ng isang opsyon sa bawat hilera.',
    selectAllOptionsRow: 'Pumili ng lahat ng naaangkop na opsyon para sa bawat hilera.',
    dragAndDropResponse: 'I-drag at i-drop ang mga opsyon upang ayusin ayon sa kagustuhan.',
    rankOrderDesktopInstruction: 'I-drag and drop ang mga item para i-rank, o gamitin ang + na pindutan para magdagdag ng item. Gamitin ang mga arrow button para muling ayusin o ang delete button para mag-alis ng item.',
    alert: "Babala",
    error: 'Mangyaring maglagay ng numero sa pagitan ng {min} at {max}.',
    cameras: 'Mga Kamera',
    microphones: 'Mga Mikropono',
    recording: 'Pagre-record',
    noDevicesFound: 'Walang nahanap na device',
    camera: 'Kamera',
    microphone: 'Mikropono',
    stopRecording: 'Itigil ang pagre-record',
    startRecording: 'Simulan ang pagre-record',
    disableCamera: 'Huwarin ang Kamera',
    enableCamera: 'Gamitin ang Kamera',
    disableMicrophone: 'Huwarin ang Mikropono',
    enableMicrophone: 'Gamitin ang Mikropono',
    settings: 'Mga Setting',
    recordingProgress: 'Pag-unlad ng Pagre-record',
    playbackProgress: 'Pag-unlad ng Pagpaparetro',
    play: 'I-play',
    pause: 'Paumahin',
    stop: 'Itigil',
    record: 'I-record',
    recordAgain: 'Magrekord muli',
    retry: 'Subukang muli',
    done: 'Tapos',
    minRecordTime: 'Mangyaring magrekord ng sagot sa loob ng {min} segundo.',
    enlargeImage: 'Palakihin ang larawan',
    enlargedImage: 'Pinalaking larawan',
    close: 'Isara',
    zoomIn: 'I-zoom in',
    zoomOut: 'I-zoom out',
    resetZoom: 'I-reset ang zoom',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} sa {total}',
    previousImage: 'Nakaraang larawan',
    nextImage: 'Susunod na larawan',
    imageLoading: 'Nilo-load ang larawan',
    imageLoadFailed: 'Hindi ma-load ang larawan',
  },
  noSelection: "Walang Napili",
  actions: {
    increase: 'Dagdagan',
    decrease: 'Bawasan'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Natapos ang Preview ng Survey',
      titleCompleted: 'Nakumpleto ang Preview ng Survey',
      previewModeWarning: 'Ang pahinang ito ay makikita lamang sa Preview Mode at hindi ipapakita sa mga totoong respondente.',
      reachedEndPoint: 'Naabot na ng survey na ito ang isang end point.',
      reachedEndPointCompleted: 'Naabot na ng preview na ito ang isang end point.',
      returnToModify: 'Bumalik sa nakaraang tanong upang baguhin ang iyong mga sagot at subukan ang ibang survey path.',
      logic: 'Lohika'
    }
  }
}
